import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

interface CollapsibleProps {
  isCollapsed: boolean;
}

export const StyledContainerCollapsible = styled.div<Props>`
  border: 1px solid #ededed;
  box-shadow: none;
  flex-flow: column wrap;
  justify-content: space-between;
  background-color: #fafafa;
  width: 100%;
  margin-bottom: 50px;
`;

export const StyledHeader = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;
  min-height: 96px;
  height: 90px;
  max-height: 152px;
  padding: 16px 35px;
  width: 100%;
  background-color: $White;
  cursor: pointer;
  border-radius: 0 0 4px 4px;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid #ededed;
`;

export const StyledTitle = styled.div<Props>`
  display: flex;
  font-weight: bold;
  margin-bottom: 0;
  font-size: 1.5rem;
`;

export const StyledExtraComponent = styled.div<Props>`
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  margin-bottom: 0px;
  margin-left: 24px;
`;

export const StyledIcon = styled.div<Props>`
  margin-left: 24px;

  i {
    margin-left: auto;
  }
`;

export const StyledContent = styled.div<CollapsibleProps>`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding: 26px 40px;
  ${(props) =>
    props.isCollapsed &&
    `
    display: none;
  `}
`;
